import { render, staticRenderFns } from "./SetConversationType.vue?vue&type=template&id=84bab856&scoped=true&"
import script from "./SetConversationType.vue?vue&type=script&lang=js&"
export * from "./SetConversationType.vue?vue&type=script&lang=js&"
import style0 from "./SetConversationType.vue?vue&type=style&index=0&id=84bab856&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bab856",
  null
  
)

export default component.exports